import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/Card/Card";

interface ChartEmptyStateProps {
  title: string;
}

/**
 * Uniform stand-in for a chart with no data. Charts must render this
 * instead of returning null — a missing chart collapses its scroll-anchor
 * div to zero height, which breaks the ChartIndex jump links and the
 * scroll-spy highlight (#9292 QA finding).
 */
export function ChartEmptyState({ title }: ChartEmptyStateProps) {
  return (
    <Card className="w-full overflow-hidden">
      <CardHeader>
        <CardTitle className="text-fontColor dark:text-light">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="py-10 text-center text-sm text-gray-500 dark:text-gray-400">
          No data available.
        </p>
      </CardContent>
    </Card>
  );
}
